import { Component, OnInit, ChangeDetectorRef, OnChanges, SimpleChanges, Input } from '@angular/core';
import { Router } from '@angular/router';
import { HubTypeEnum, IMenuItem, MenuListData, NavigationService } from 'projects/shared/src/services/navigation.service';
import { LookupsService } from 'projects/shared/src/services/lookups.service';
import { AuthenticationService } from 'projects/shared/src/services/authentication.service';
import { User } from 'projects/shared/src/models/auth';
import { SystemModule } from '../../../features/central-hub/models/enums/SystemModule';
@Component({
  selector: 'app-sidebar',
  standalone: false,
  templateUrl: './sidebar.component.html',
})
export class SidebarComponent implements OnInit, OnChanges {
  nav: MenuListData = new MenuListData();
  selectedItem: IMenuItem | null = null;
  // appRedirectUrl = environment.appRedirectUrl;
  currentUser: User | any = new User();
  @Input({ required: true }) currentModuleCode!: SystemModule;
  hubTypeEnum = HubTypeEnum;
  dataLoading = false;
  skeletonItems = Array(7).fill(0);

  constructor(
    public navService: NavigationService,
    public LookupsService: LookupsService,
    public authenticationService: AuthenticationService,
    private cdr: ChangeDetectorRef,
    public router: Router
  ) {
    this.currentUser = this.authenticationService.currentUserValue;
  }

  ngOnInit(): void {
    // this.getMenuItems();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes['currentModuleCode'] && changes['currentModuleCode'].currentValue) {
      this.getMenuItems();
    }
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  getMenuItems() {
    this.dataLoading = true;
    const currentUrl = this.router.url;
    const urlParts = currentUrl.split('/').filter(Boolean);
    this.LookupsService.getMenuBasedOnPermissions(this.currentModuleCode).subscribe(
      (data: MenuListData) => {
        this.dataLoading = false;
        if (data && data.menuList && data.menuList.length > 0) {
          this.nav = data as MenuListData;
          if (urlParts.length < 3) {
            if (this.nav.menuList[0].subMenu && this.nav.menuList[0].subMenu.length > 0) {
              this.router.navigate([this.nav.menuList[0].subMenu[0].route], { replaceUrl: true });
            } else {
              this.router.navigate([this.nav.menuList[0].route], { replaceUrl: true });
            }
          }
        } else {
          // this.router.navigate(['/main/central-hub'], { replaceUrl: true });
        }
      },
      (error: any) => {
        this.dataLoading = false;
        // this.authenticationService.logout();
        this.router.navigate(['/main/central-hub'], { replaceUrl: true });
      });
  }
  isActiveMenu(link: string): boolean {
    if (!link) return false;

    // Turn whatever you passed—full URL or path—into a clean pathname:
    let linkPath: string;
    try {
      // If it's a full URL, this will work; if not, it throws:
      linkPath = new URL(link, window.location.origin).pathname;
    } catch {
      // Fallback: assume it's already a relative path (with or without leading slash)
      linkPath = link.startsWith("/") ? link : `/${link}`;
    }

    const path = window.location.pathname;
    // Exact match
    if (path === linkPath) {
      return true;
    }

    // Prefix match only if followed by a slash (so "/admin/rights" ✅ but
    // "/admin/rights-console" ❌)
    return path.startsWith(linkPath + "/");
  }

  selectItem(item: IMenuItem) {
    if (item.active) {
      this.nav.menuList.forEach(element => {
        element.active = false;
      });
      this.selectedItem = null;
    } else {
      this.selectedItem = item;
      this.setActiveMainItem(item);
    }
  }

  setActiveMainItem(item: IMenuItem) {
    this.nav.menuList.forEach(element => {
      element.active = false;
    });
    item.active = true;
  }

  toggelSidebar() {
    const navState = this.navService.sidebarState;
    navState.sidenavOpen = !navState.sidenavOpen;
  }

}
